import React from 'react';
import Spin from 'react-spinkit';

const Spinner = () => {
  return <Spin name="pacman" color="aqua" className="spinner"/>;
};

export default Spinner;